var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration-and-Tutorials",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations-2020",
    transform: "translate(-353.000000, -198.000000)",
    fill: "#3E98FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "THUMBNAIL",
    transform: "translate(214.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(139.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settinngs",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2.25 C5.74342105,2.25 6.75,3.25657895 6.75,4.5 C6.75,5.74342105 5.74342105,6.75 4.5,6.75 C3.25657895,6.75 2.25,5.74342105 2.25,4.5 C2.25,3.25657895 3.25657895,2.25 4.5,2.25 Z M3.64285714,0 L3.43928571,1.125 C3.23571429,1.18928571 3.05357143,1.26428571 2.87142857,1.36071429 L1.92857143,0.707142857 L0.707142857,1.92857143 L1.36071429,2.87142857 C1.26428571,3.05357143 1.18928571,3.24642857 1.125,3.43928571 L0,3.64285714 L0,5.35714286 L1.125,5.56071429 C1.18928571,5.76428571 1.275,5.94642857 1.36071429,6.12857143 L0.707142857,7.07142857 L1.91785714,8.28214286 L2.86071429,7.62857143 C3.04285714,7.725 3.23571429,7.8 3.43928571,7.86428571 L3.64285714,9 L5.35714286,9 L5.56071429,7.875 C5.76428571,7.81071429 5.94642857,7.73571429 6.12857143,7.63928571 L7.07142857,8.29285714 L8.28214286,7.07142857 L7.62857143,6.12857143 C7.725,5.94642857 7.8,5.75357143 7.86428571,5.56071429 L9,5.35714286 L9,3.64285714 L7.875,3.43928571 C7.81071429,3.24642857 7.73571429,3.05357143 7.63928571,2.87142857 L8.29285714,1.92857143 L7.07142857,0.717857143 L6.12857143,1.37142857 C5.94642857,1.275 5.75357143,1.2 5.56071429,1.13571429 L5.35714286,0 L3.64285714,0 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.b4384738ec7c0930c2cab51da1b7409d.svg";
export { ForwardRef as ReactComponent };